import React from 'react';
import compose from 'lodash/fp/compose';
import { useQuery, useApolloClient } from '@apollo/client';
import { withMetrics } from '@catalogo/core-metrics';
import { ToggleBuyTogether } from '@catalogo/service-americanas-product/src/payment/buy-together-vip.graphql';
import { CompreJuntoVipMobile } from '@catalogo/service-americanas-product/src/queries/buy-together-vip.graphql';
import {
  getBuyTogetherProductId,
  ftmProductImage,
  closureBuyTogether,
} from '@catalogo/service-americanas-product/src/helpers/buy-together-vip';
import { WithBuyTogetherVipProps, WithBuyTogetherVipStateProps } from '../types';

export const withBuyTogetherVipState = (Component: React.FC) => (props: WithBuyTogetherVipStateProps) => {
  const { data: buyTogether } = useQuery(ToggleBuyTogether);
  const active = buyTogether?.buyTogetherVIP?.active ?? false;

  const componentProps = {
    ...props,
    active,
  };

  return <Component {...componentProps} />;
};

export const withBuyTogetherVip = (Component: React.FC) => (props: WithBuyTogetherVipProps) => {
  const { shelf, active, dispatchMetrics } = props;
  const client = useApolloClient();
  const buyTogetherProductId = getBuyTogetherProductId(shelf);

  const { loading, error, data } = useQuery(CompreJuntoVipMobile, {
    variables: {
      productId: buyTogetherProductId,
    },
    skip: !buyTogetherProductId,
  });

  const product = data?.product;
  const offer = product?.offers?.result?.[0];
  const price = offer?.salesPrice ?? null;
  const sku = offer?.sku ?? null;
  const sellerId = offer?.seller?.id ?? null;
  const offerId = offer?.id ?? null;
  const name = product?.name ?? '';

  const handleBuyTogether = closureBuyTogether(
    client,
    dispatchMetrics,
    ToggleBuyTogether,
    active,
    price,
    sku,
    sellerId,
    offerId,
    buyTogetherProductId,
    name,
    ftmProductImage(product)
  );
  const isO2O = props?.currentSku?.offers?.result[0]?.seller?.id === '33014556000196';

  const buyTogetherVipProps = {
    loading,
    error,
    data,
    active,
    buyTogetherProductId,
    image: product ? ftmProductImage(product) : null,
    title: name,
    price,
    handleBuyTogether,
    isO2O,
  };

  return <Component {...props} {...buyTogetherVipProps} />;
};

export default compose(withMetrics, withBuyTogetherVipState, withBuyTogetherVip);
